import { connect } from 'react-redux';
import {
	signupNormal,
	loginNormal,
	forgetPassword,
	setNewPassword,
	resendVerifyEmail,
} from 'actions/auth';

import { openMessageModal, closeMessageModal } from 'actions/modal';
import { closeAlert } from 'actions/alert';

import Signup from './component';

const mapStateToProps = ({ alert: { loginSignup: { option: { type } } }, i18n: { lan } }) => ({
	alertType: type,
	lan,
});

const mapDispatchToProps = dispatch => ({
	onSignup: () => dispatch(signupNormal()),
	onLogin: () => dispatch(loginNormal()),
	onChangeToLogin: () => {
		dispatch(closeAlert('loginSignup'));
		dispatch(openMessageModal('loginSignup', { type: 'loginForm' }));
	},
	onChangeToSignup: () => {
		dispatch(closeAlert('loginSignup'));
		dispatch(openMessageModal('loginSignup', { type: 'signup' }));
	},
	onChangeToForget: () => {
		dispatch(closeAlert('loginSignup'));
		dispatch(openMessageModal('loginSignup', { type: 'forgetPassword' }));
	},
	onSendForget: () => dispatch(forgetPassword()),
	onSetPassword: () => dispatch(setNewPassword()),
	onResendVerifyEmail: () => dispatch(resendVerifyEmail()),
	onCloseLoginSignupModal: () => dispatch(closeMessageModal('loginSignup')),
});

export default connect(mapStateToProps, mapDispatchToProps)(Signup);



// WEBPACK FOOTER //
// ./src/components/molecules/Signup/index.js